import ApiService from '@/common/api.service'
import { 
  FETCH_LEADERBOARD_DATA_URL,
  FETCH_LEADERBOARD_TEAMS_URL,
  FETCH_PLAYER_LEADERBOARD_URL,
  SYSTEM_WIDE_ACTIVITY_PRIVACY_URL
} from '@/constants/ApiConstants';
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'

const state = {
  filter: {},
  preview: 'MINUTES',
  scope: 'UNIVERSE',
  aggregationMethod: 'SUM',
  timeFrame: 'CURRENT_WEEK',
  teams : [],
  data: {},
  selectedTeamLeaderboard: null,
  noData: false,
  teamIndividual : 'team'
}

const getters = {
  leaderboardPreviewMode: state => state.preview,
  leaderboardSort: state => state.sort,
  leaderboardFilter: state => state.filter,
  leaderboardData: state => state.data,
  leaderboardScope: state => state.scope,
  leaderboardAgrgationMethod: state => state.aggregationMethod,
  leaderboardTeams: state => state.teams,
  selectedTeamLeaderboard : state => state.teams[0],
  leaderboardTimeFrame : state => state.timeFrame,
  updateNoData : state => state.noData,
  leaderboardTeamIndividual : state => state.teamIndividual
}

const actions = {
  [action.FETCH_LEADERBOARD_TEAMS] ({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      ApiService.get(FETCH_LEADERBOARD_TEAMS_URL)
        .then(({data}) => {
          commit(mutation.UPDATE_LEADERBOARD_TEAMS, data);
          commit(mutation.SELECT_LEADERBOARD_TEAM, data[0]);
          if (data.length > 0) {
            dispatch(action.FETCH_LEADERBOARD_DATA);
            commit(mutation.UPDATE_NO_DATA_FLAG, false);
          } else {
            commit(mutation.UPDATE_NO_DATA_FLAG, true);
          }
          return resolve(data);
        })
        .catch(error => reject(error))
    })
  },

  [action.FETCH_LEADERBOARD_DATA] ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      ApiService.get(FETCH_LEADERBOARD_DATA_URL, {
        teamId: state.selectedTeamLeaderboard.teamId,
        scope: state.scope,
        dataType: state.preview,
        aggregationMethod: state.preview === 'MINUTES' ? state.aggregationMethod : null,
        timeFrame: state.timeFrame
        
      })
        .then(({ data }) => { 
          commit(mutation.UPDATE_LEADERBOARD_DATA, data);
          return resolve(data);
        })
        .catch(error => reject(error))
    })
  },
  [action.FETCH_PLAYER_LEADERBOARD_DATA] ({ commit, state }, playerId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${FETCH_PLAYER_LEADERBOARD_URL.replace(':playerId', playerId)}`, {
        scope: state.scope,
        dataType: state.preview,
        aggregationMethod: state.preview === 'MINUTES' ? state.aggregationMethod : null,
        timeFrame: state.timeFrame
        
      })
        .then(({ data }) => { 
          commit(mutation.UPDATE_LEADERBOARD_DATA, data);
          commit(mutation.UPDATE_NO_DATA_FLAG, false);

          return resolve(data);
        })
        .catch(error => reject(error))
    })
  },
  [action.UPDATE_LEADERBOARD_SELECTED_TEAM] ({ commit, dispatch }, team) {
    commit(mutation.SELECT_LEADERBOARD_TEAM, team);
    dispatch(action.FETCH_LEADERBOARD_DATA, team.teamId);
  },
  [action.CHANGE_LEADERBOARD_TEAM_INDIVIDUAL] ({ commit, dispatch }, payload) {
    commit(mutation.UPDATE_LEADERBOARD_TEAM_INDIVIDUAL, payload.teamIndividual);
    if (payload.teamIndividual === "individual") {
      dispatch(action.FETCH_PLAYER_LEADERBOARD_DATA, payload.playerId);
    } else {
      dispatch(action.FETCH_LEADERBOARD_TEAMS);
    }
  },
  [action.CHANGE_LEADERBOARD_SCOPE] ({ commit, dispatch }, payload) {
    commit(mutation.UPDATE_LEADERBOARD_SCOPE, payload.scope);
    if (!state.noData) {
      if (state.teamIndividual === "individual") {
        dispatch(action.FETCH_PLAYER_LEADERBOARD_DATA, payload.playerId);
      } else {
        dispatch(action.FETCH_LEADERBOARD_DATA);
      }
    }
  },
  [action.CHANGE_LEADERBOARD_AGREGATION_METHOD] ({ commit, dispatch }, payload) {
    commit(mutation.UPDATE_LEADERBOARD_AGREGATION_METHOD, payload.aggrMethod);
    if (!state.noData) {
      if (state.teamIndividual === "individual") {
        dispatch(action.FETCH_PLAYER_LEADERBOARD_DATA, payload.playerId);
      } else {
        dispatch(action.FETCH_LEADERBOARD_DATA);
      }
    }
  },
  [action.CHANGE_LEADERBOARD_TIME_FRAME] ({ commit, dispatch }, payload) {
    if (state.timeFrame !== payload.timeFrame) {
      commit(mutation.UPDATE_LEADERBOARD_TIME_FRAME, payload.timeFrame);
      if (state.teamIndividual === "individual") {
        dispatch(action.FETCH_PLAYER_LEADERBOARD_DATA, payload.playerId);
      } else {
        dispatch(action.FETCH_LEADERBOARD_DATA);
      }
    }
  },
  [action.DESTROY_LEADERBOARD_DATA] ({ commit }) {
    commit(mutation.DESTROY_LEADERBOARD_DATA)
  },
  [action.UPDATE_SYSTEM_WIDE_PRIVACY] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .put(`${SYSTEM_WIDE_ACTIVITY_PRIVACY_URL.replace(':playerId', payload.playerId).replace(':privacyBoolean', payload.privacy)}`)
        .then(({ data }) => {
          // from player module
          commit(mutation.UPDATE_SYSTEM_PRIVACY, payload.systemWideActivityPrivacy);
          return resolve(data);
        })
        .catch(error => reject(error))
    })
  },
  [action.UPDATE_ACCOUNT] ({ commit }, payload) {
    commit(mutation.SET_CHOSEN_ACCOUNT, payload);
  }

}

const mutations = {
  [mutation.SET_CHOSEN_ACCOUNT] (state, payload) {
    state.account = payload
    window.localStorage.setItem('account', JSON.stringify(payload))
  },
  [mutation.UPDATE_LEADERBOARD_TEAMS] (state, data) {
    state.teams = data;
    state.teamIndividual = 'team';
  },
  [mutation.UPDATE_NO_DATA_FLAG] (state, show) {
    state.noData = show;
  },
  [mutation.SELECT_LEADERBOARD_TEAM] (state, data) {
    state.selectedTeamLeaderboard = data;
  },
  [mutation.UPDATE_LEADERBOARD_DATA] (state, data) {
    state.data = data;
  },
  [mutation.UPDATE_LEADERBOARD_TEAM_INDIVIDUAL] (state, teamIndividual) {
    state.teamIndividual = teamIndividual;
  },
  [mutation.UPDATE_LEADERBOARD_SORT] (state, sort) {
    state.sort = sort;
  },
  [mutation.UPDATE_LEADERBOARD_FILTER] (state, filter) {
    state.filter = filter;
  },
  [mutation.UPDATE_LEADERBOARD_SCOPE] (state, scope) {
    state.scope = scope;
  },
  [mutation.UPDATE_LEADERBOARD_AGREGATION_METHOD] (state, aggregationMethod) {
    state.aggregationMethod = aggregationMethod;
  },
  [mutation.UPDATE_LEADERBOARD_TIME_FRAME] (state, timeFrame) {
    state.timeFrame = timeFrame;
  },
  [mutation.DESTROY_LEADERBOARD_DATA] (state) {
    state.data = {};
    state.noData = false;
    state.teamIndividual = 'team';
    state.timeFrame = 'CURRENT_WEEK';
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}